import { MouseEvent as ReactMouseEvent } from 'react';

export type Camelize<S extends string> = S extends `${infer P1}_${infer P2}${infer P3}`
  ? `${Lowercase<P1>}${Uppercase<P2>}${Camelize<P3>}`
  : Lowercase<S>;

/**
 * String-represented variant of keyboard keys assigning.
 * Number based variant is deprecated in typing and harder to use.
 */
export enum EKey {
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  I = 'KeyI',
  O = 'KeyO',
  P = 'KeyP',
  K = 'KeyK',
  L = 'KeyL',
  D = 'KeyD',
  ENTER = 'Enter',
}

/**
 * Placeholder for default fallback value that can used as react default prop or placeholder function that does nothing.
 */
export function CallablePlaceholder(): void {
  /* Just placeholder */
}

/**
 * Placeholder for default async fallback value that can used as react default prop or placeholder function that does nothing.
 */
export async function CallablePlaceholderAsync(): Promise<void> {
  /* Just placeholder */
}

/**
 * Placeholder for react components that just renders empty space.
 */
export function ComponentPlaceholder(): null {
  return null;
}

/**
 * Placeholder for react components that just renders empty space.
 */
export function StopPropagation(event: MouseEvent | ReactMouseEvent): null {
  event.stopPropagation();
  event.preventDefault();
  return null;
}
